// extracted by mini-css-extract-plugin
module.exports = {"item":"snackbars_item_ezeDA"};